<template>
  <div>
    <div class="product-list" :class="isGrid? 'product-list-g':''" >
        <div v-for="(item, key) in productList" :key="key" >
            <div @click="handleDetail(item)" class="product-item" v-if="!isGrid">
                <div class="rank-flag" v-if="isRank && key<3" >
                    <hkj-svg iconName="icon--1" :class="'icon-' + key"></hkj-svg>
                    <!-- <img v-if="key==0" src="../../assets/images/icon/rank_0.png" mode=""/> -->
                    <!-- <img v-if="key==1" src="../../assets/images/icon/rank_1.png" mode=""/> -->
                    <!-- <img v-if="key==2" src="../../assets/images/icon/rank_2.png" mode=""/> -->
                    <span>{{key+1}}</span>
                </div>
                <img class="product-img" :src="item.imageInfo.imageList[0].url" mode="" />
                <div class="item-content">
                    <div class="title-wrap">
                        <span class="ems">{{item.shopInfo.shopName}}</span>
                    </div>
                    <div class="title-wrap">
                        <span class="title">{{item.skuName}}</span>
                    </div>
                    <div class="plus-wrap">
                        <span class="plus" v-if="item.plus">PLUS</span>
                        <span class="border-badge" v-for="(subItem, index) in item.skuTagList" :key="index">{{subItem.name}}</span>
                        <span class="bg-badge" v-if="item.shenghe">急速审核</span>
                        <span class="bg-badge" v-if="item.seven">7天价保</span>
                        <span class="bg-badge" v-if="item.shenghe">闪电退款</span>
                        <span class="bg-badge" v-if="item.later">晚发赔</span>
                    </div>
                    <div class="commission-wrap">
                        <span v-if="loginType === 'up'" class="commission-rate">佣金 {{item.commissionInfo.commissionShare}}%</span>
                        <span class="evaluation">{{item.estimateValidOrders}}{{item.estimateValidOrders > 0 ? '+' : ''}}件售出</span>
                        <span class="evaluation">{{item.goodCommentsShare}}%好评</span>
                    </div>
                    <!-- <div class="footer-wrap">
                        <span class="price">到手价￥{{item.priceInfo.lowestPrice}}</span>
                        <button wx:if="{{!isSearch}}" open-type="share" data-good="{{item}}" class="go-ref">一键转发</button>
                        <button wx:if="{{isSearch}}" class="go-ref">一键转链</button>
                    </div> -->
                </div>
            </div>
            <div @click="handleDetail(item)" class="product-item-g" v-if="isGrid">
                <div class="product-item-img-wrap">
                    <img class="product-img-g" ref="product_item_g" :style="imgStyle" :src="item.imageInfo.imageList[0].url" mode="" />
                    <span class="product-img-tip-g">{{item.shopInfo.shopName}}</span>
                </div>
                <div class="product-item-title-wrap">
                    <span class="title">{{item.skuName}}</span>
                </div>
                <div class="product-item-g-price-wrap">
                    <div class="product-item-g-price">
                        <div class="g-price price-item flex-one">
                            <span class="title">到手价</span>
                            <span class="value">{{item.priceInfo.lowestPrice}}</span>
                        </div>
                        <div class="g-commission price-item flex-one" v-if="loginType === 'up'">
                            <span class="title">佣金({{item.commissionInfo.commissionShare}}%)</span>
                            <span class="value">{{item.commissionInfo.commission}}</span>
                        </div>
                        <div class="g-butie price-item flex-one">
                            <span class="title">好评</span>
                            <span class="value">{{item.goodCommentsShare}}%</span>
                        </div>
                    </div>
                </div>
                <div class="product-item-g-date">结束：{{item.couponTime}}</div>
                <div class="product-item-g-btn-wrap">
                    <!-- <button wx:if="{{!isSearch}}" open-type="share" data-good="{{item}}" class="go-ref">一键转发</button> -->
                    <!-- <button wx:if="{{!isSearch}}" data-good="{{item}}" class="go-ref" >一键转发</button> -->
                </div>
            </div>
        </div>
    </div>
    <div v-if="!isCoupon">
        <div v-if="hasMore">
            <div class="load-more"><span>上滑加载更多</span></div>
        </div>
        <div v-if="!hasMore">
            <div class="load-more"><span>没有更多了</span></div>
        </div>
    </div>
  </div>
</template>
<script>
import HkjSvg from '@/components/svg/index.vue'
import { loginStore } from '@/store';

export default {
    components: {
        HkjSvg
    },
    name: 'GoodList',
    props: {
        isGrid: Boolean,
        productList: Array,
        hasMore: Boolean,
        isCoupon: Boolean,
        isRank: Boolean,
        isSearch: Boolean
    },
    data() {
        return {
            resizeStyle: {},
            loginType: ''
        }
    },
    created() {
        this.loginType = loginStore.getLoginType()
    },
    watch: {
        productList() {
            
        }
    },
    computed: {
        imgStyle() {
            return this.resizeStyle
        }
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.resizeStyle = this.getResizeSize()
        })
    },
    methods: {
        getResizeSize() {
            let wd = (document.querySelector('body').clientWidth - 30 ) / 2 + 'px'
            this.resizeStyle = {
                width: wd,
                height: wd
            }
        },
        handleDetail(item) {
            if (this.isCoupon) return
            if (this.isSearch) {
                this.$router.push(`/coupon/${item.itemId}`)
            } else {
                this.$router.push(`/productDetail/${item.skuId}`)
            }
        }
    }
}
</script>
<style scoped>
.product-list {
    margin-top: var(--len10);
}

.product-item {
    position: relative;
    margin-bottom: var(--len10);
    background-color: white;
    padding: var(--len10);
    display: flex;
}

.product-img {
    width: var(--len120);
    height: var(--len120);
    border-radius: var(--len3);
    margin-right: var(--len10);
}

.item-content {
    flex: 1;
}

.title-wrap {
    display: flex;
}

.title-wrap .ems {
    color: white;
    font-size: var(--len14);
    height: var(--len14);
    line-height: var(--len14);
    background-color: var(--primary-color);
    padding: var(--len3) var(--len5);
    border-radius: var(--len3);
    margin-right: var(--len10);
}

.title-wrap .title {
    font-size: var(--len14);
    /* font-weight: bold; */
    color: black;
    /* margin-left: var(--len10); */
    height: var(--len20);
    line-height: var(--len20);
    overflow: hidden;
    flex: 1;
    margin:4px 0px;
}

.plus-wrap {
    height: var(--len46);
    overflow: hidden;
    width: 100%;
}

.plus {
    background-color: var(--primary-color);
    color: white;
    font-size: var(--len12);
    border-radius: 2px;
    padding: 0 var(--len3);
    margin-right: var(--len5);
}

.border-badge {
    border: 1px solid var(--primary-color);
    padding: 0 var(--len5);
    line-height: var(--len14);
    height: var(--len14);
    color: var(--primary-color);
    font-size: var(--len12);
    margin-right: var(--len5);
    white-space: nowrap;
    border-radius: var(--len3);
    margin-top: var(--len5);
    display: inline-block;
}

.bg-badge {
    background-color: rgba(255, 165, 0, 0.3);
    padding: 0 var(--len5);
    line-height: var(--len14);
    height: var(--len14);
    color: var(--primary-color);
    font-size: var(--len12);
    margin-right: var(--len5);
    border-right: var(--len3);
    white-space: nowrap;
}

.commission-wrap {
    height: var(--len16);
}

.commission-rate {
    font-size: var(--len12);
    color: var(--primary-color);
}

.evaluation {
    color: gray;
    font-size: var(--len12);
    margin-left: var(--len10);
}

.footer-wrap {
    height: var(--len40);
    display: flex;
    justify-content: end;
    align-items: flex-end;
    display: flex;
}

.price {
    font-size: var(--len12);
    color: var(--primary-color);
    flex: 1;
    margin-right: var(--len20);
}

.go-ref {
    width: var(--len80) !important;
    padding: 0 var(--len5);
    height: var(--len30);
    line-height: var(--len30);
    background-color: var(--primary-color);
    border-radius: var(--len30);
    font-size: var(--len14);
    font-weight: normal;
    color: white;
}

.load-more {
    text-align: center;
    color: #cccccc;
}
/** 两列的 Product list */
.product-list-g{
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: var(--len10);
    /* --webket-box-pack: justify; */
    /* justify-content: space-between; */
}
.product-item-g{
    /* flex: 1 1 50%; */
    /* width: calc(50% - var(--len5)); */
    background-color: white;
    margin-bottom: var(--len10);
}
.product-item-img-wrap {
    position: relative;
    width: 100%;
}
.product-item-g .product-img-g{
    width: 100%;
    /* height: var(--len200); */
    display: block;
}
.product-img-tip-g{
    width: 100%;
    height: var(--len25);
    line-height: var(--len25);
    display: block;
    position: absolute;
    bottom: 0;
    background-color: var(--primary-color);
    color: white;
    font-size: var(--len12);
    text-align: center;
    /* span-align: center; */
}
.product-item-title-wrap,.product-item-g-price-wrap{
    padding: 0 var(--len5);
    margin-top: var(--len5);
}
.product-item-title-wrap{
    height: var(--len46);
    overflow: hidden;
}
.product-item-title-wrap .title{
    font-size: var(--len14);
}
.product-item-g-price{
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: var(--len5);
    padding: var(--len5);
}
.rank-flag{
    position: absolute;
    top: 0;
    left: var(--len_3);
}
.rank-flag span{
    position: absolute;
    top: 0.5rem;
    color:white;
    left: 0.6875rem;
    font-size: var(--len12);
}
.rank-flag img{
    width: var(--len30);
    height: var(--len40);
}
.product-item-g-price-wrap{
    padding: 0 var(--len5);
}
.product-item-g-price {
    display: flex;
    font-size: var(--len12);
    /* background-color: orange; */

}
.price-item .title, .price-item .value{
    display: block;
    text-align: left;
    text-indent: var(--len5);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    /* min-width: var(--len60); */
}
.price-item .value{
    margin-top: var(--len3);
    font-weight: bold;
}
.product-item-g-date{
    font-size: var(--len12);
    text-align: center;
    /* span-align: center; */
    height: var(--len20);
    line-height: var(--len20);
}
.product-item-g-btn-wrap {
    padding: 0 var(--len10);
    margin-bottom: var(--len5);
}
.product-item-g-btn-wrap button{
    width: 100%!important;
}
</style>